import { render } from "./SearchBox.vue?vue&type=template&id=235078ac&scoped=true"
import script from "./SearchBox.vue?vue&type=script&lang=js"
export * from "./SearchBox.vue?vue&type=script&lang=js"

import "./SearchBox.vue?vue&type=style&index=0&id=235078ac&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-235078ac"

export default script